import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import image1 from '../assets/images/studio/2.jpg'
import image2 from '../assets/images/studio/4.jpg'
import image3 from '../assets/images/studio/6.jpg'
import image4 from '../assets/images/studio/8.jpg'

import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css'; 

export default function TopCoworkingCity() {
    let [isOpen, setisOpen] = useState(false);
    let [currentImageIndex, setCurrentImageIndex] = useState(0);

   let data = [
        {
            image:image1,
            name:'Colors Magazine',
            title:'Web Design'
        },
        {
            image:image2,
            name:'Riser Coffee',
            title:'Branding'
        },
        {
            image:image3,
            name:'Dancing With Myself',
            title:'Photography'
        },
        {
            image:image4,
            name:'Riser Coffee',
            title:'Branding'
        },
    ]
   let images = [image1,image2,image3,image4]

   let handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setisOpen(true);
};
let handleMovePrev = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + images.length - 1) % images.length);
};

let handleMoveNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
};
let currentImage = images[currentImageIndex];

  return (
    <>
        <div className="row mt-4 pt-2" data-masonry='{"percentPosition": true }'>
            {data.map((item,index)=>{
                return(
                    <div className="col-lg-3 col-md-6 spacing canada" key={index}>
                        <div className="work-container position-relative d-block overflow-hidden rounded">
                            <Link to="#" onClick={() => handleImageClick(index)} className="lightbox d-inline-block" title="">
                                <img src={item.image} className="img-fluid" alt=""/>
                            </Link>
                            <div className="content bg-white p-3">
                                <Link to="/page-work-single" className="title d-block fw-bold text-dark">{item.name}</Link>
                                <small className="text-muted">{item.title}</small>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>

        {isOpen && (
            <Lightbox
                mainSrc={currentImage}
                prevSrc={images[(currentImageIndex + images.length - 1) % images.length]}
                nextSrc={images[(currentImageIndex + 1) % images.length]}

                onCloseRequest={() => setisOpen(false)}
                onMovePrevRequest={handleMovePrev}
                onMoveNextRequest={handleMoveNext}
            />
        )}
    </>

  )
}
